import Get from '../services/Get';
import Put from '../services/Put';

import { nexcareVersion } from '../config/serviceConfig';

const getDataTicketInitiateSolution = (token) => Get(`/${nexcareVersion}/nexcare/ticket/resolved/initiate`, token);
const getDataTicketSolution = (page, limit, orderBy, token) => Get(`/${nexcareVersion}/nexcare/ticket/resolved?page=${page}&limit=${limit}&order=${orderBy}`, token);
const getDetailDataTicketSolution = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/resolved/${id}`, token);

const getDataTicketSolutionFilterInitiate = (filter, token) => Get(`/${nexcareVersion}/nexcare/ticket/resolved/initiate${filter}`, token);
const getDataTicketSolutionFilter = (page, limit, filter, orderBy, token) => Get(`/${nexcareVersion}/nexcare/ticket/resolved?page=${page}&limit=${limit}${filter}&order=${orderBy}`, token);

const getListUserCustomerService = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/user-cs?page=${page}&limit=${limit}`, token);
const getDetailUserCustomerService = (id, token) => Get(`/${nexcareVersion}/nexcare/user-cs?filter=${id}`, token);
const getSearchUserCustomerService = (page, limit, filter, token) => Get(`/${nexcareVersion}/nexcare/user-cs?page=${page}&limit=${limit}&filter=alias_name like ${filter}`, token);

const getListUserCSTicketSolution = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/ticket-resolved/user-cs?page=${page}&limit=${limit}&order=alias_name asc`, token);
const getSearchUserCSTicketSolution = (page, limit, filter, token) => Get(`/${nexcareVersion}/nexcare/ticket-resolved/user-cs?page=${page}&limit=${limit}&filter=alias_name like ${filter}&order=alias_name asc`, token);
const getListPriorityTicketSolution = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/ticket-resolved/remark/priority?page=${page}&limit=${limit}`, token);

const putDataReleaseVersion = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/resolved/release-version/${id}`, data, token);
const putDataRedmine = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/resolved/redmine/${id}`, data, token);

const API_SOLUTION = {
    getDataTicketInitiateSolution,
    getDataTicketSolution,
    getDetailDataTicketSolution,
    getDataTicketSolutionFilterInitiate,
    getDataTicketSolutionFilter,
    getListUserCustomerService,
    getDetailUserCustomerService,
    getSearchUserCustomerService,
    getListUserCSTicketSolution,
    getSearchUserCSTicketSolution,
    getListPriorityTicketSolution,
    putDataReleaseVersion,
    putDataRedmine
}

export default API_SOLUTION;